import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

let router = new Router({
  mode: "history",
  linkActiveClass: "active",
  routes: [
    {
      path: "/",
      component: resolve => {
        require.ensure(["@/components/Landing/index.vue"], () => {
          resolve(require("@/components/Landing/index.vue"));
        });
      }
    },
    {
      path: "/certificate/:id",
      component: resolve => {
        require.ensure(["@/components/Certificate/index.vue"], () => {
          resolve(require("@/components/Certificate/index.vue"));
        });
      }
    },
    {
      path: "/how-does-it-work",
      component: resolve => {
        require.ensure(["@/components/HowDoesItWork/index.vue"], () => {
          resolve(require("@/components/HowDoesItWork/index.vue"));
        });
      }
    }
  ]
});

export default router;
